// Grille de prix indicative — tarifs forfaitaires identiques iPhone / Android.
// Pièce d'origine = pièce compatible + 30 % (arrondi à l'euro).
import { PartQuality, RepairType } from './types';

type QualityPrices = Record<PartQuality, number>;

const ORIGINE_MARKUP = 1.3;

const COMPATIBLE_PRICES: Record<RepairType, number> = {
  batterie: 60,
  ecran: 90,
  connecteur: 110,
  'vitre-arriere': 100,
};

const withOrigine = (compatible: number): QualityPrices => ({
  compatible,
  origine: Math.round(compatible * ORIGINE_MARKUP),
});

export const PRICE_TABLE: Record<RepairType, QualityPrices> = {
  batterie: withOrigine(COMPATIBLE_PRICES.batterie),
  ecran: withOrigine(COMPATIBLE_PRICES.ecran),
  connecteur: withOrigine(COMPATIBLE_PRICES.connecteur),
  'vitre-arriere': withOrigine(COMPATIBLE_PRICES['vitre-arriere']),
};

export const getPrice = (repair: RepairType, quality: PartQuality): number =>
  PRICE_TABLE[repair][quality];
